import type { TextProps } from "../../../_core/Text/Text";
import type { CategoryMediumProps } from "../CategoryMedium/CategoryMedium";
import { CategoryMedium } from "../CategoryMedium/CategoryMedium";

export type CategoryLargeProps = CategoryMediumProps;

export const CategoryLarge = ({
  maskProps,
  titleProps,
  ...props
}: CategoryLargeProps) => (
  <CategoryMedium
    {...props}
    maskProps={{ size: "m", ...maskProps }}
    titleProps={{ size: "xl", ...titleProps } as TextProps}
  />
);
